import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[dbmClickOutside]'
})
export class ClickOutsideDirective {

    @Output() public clickOutside = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) {
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(target: any): void {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/directives/click-outside.directive.ts